import { jwtDecode } from "jwt-decode";
import { AnonymousUser, AuthJwt, AuthJwtDecoded, AuthUser } from "services/authService";

///////////////////////////////////////////////////////////////////////////////

export class SessionStore {
    static STORAGE_USER_KEY = "user";
    static STORAGE_TOKEN = "tk";

    static readToken(): AuthJwt | null {
        const sdt = window.localStorage.getItem(this.STORAGE_TOKEN);
        return (sdt != null) ? JSON.parse(sdt) as AuthJwt : null;
    }

    static readUserStored(): AuthUser | null {
        const sUser = window.sessionStorage.getItem(this.STORAGE_USER_KEY) || window.localStorage.getItem(this.STORAGE_USER_KEY);
        if (sUser != null) {
            return JSON.parse(sUser) as AuthUser;
        }
        return null;
    }

    static readUser(): AuthUser {
        const sUser = window.sessionStorage.getItem(this.STORAGE_USER_KEY) || window.localStorage.getItem(this.STORAGE_USER_KEY);
        if (sUser != null) {
            var u = JSON.parse(sUser) as AuthUser;
            if (u.keepConnected || !this.tokenExpired()) {
                return u;
            }
        }
        return AnonymousUser;
    }

    static accessToken(): string {
        const jwt = this.readToken();
        if (jwt != null) {
            return jwt.access_token;
        }
        return "";
    }

    static bearerString(): string {
        const jwt = this.readToken();
        if (jwt != null) {
            return `${jwt.token_type} ${jwt.access_token}`;
        }
        return "";
    }

    static tokenType(): string {
        const jwt = this.readToken();
        if (jwt != null) {
            return jwt.token_type;
        }
        return "";
    }

    static tokenExpired(seconds?: number): boolean {
        const jwt = this.readToken();
        if (jwt) {
            const jd = jwtDecode(jwt.access_token) as AuthJwtDecoded;
            return (jd.exp * 1000 + (jwt.expires_in - (seconds ?? 0))) < Date.now();
        }
        return true;
    }

    static storeJWT(token: AuthJwt, notify: boolean) {
        window.localStorage.setItem(this.STORAGE_TOKEN, JSON.stringify(token));

        if (notify) {
            // Notifica mudança no JWT.
            const event = new CustomEvent("storeJWT", { detail: "changed" });
            document.dispatchEvent(event);
        }
    }

    static storeUser(user: AuthUser) {
        window.sessionStorage.setItem(this.STORAGE_USER_KEY, JSON.stringify(user));

        if (user.keepConnected)
            window.localStorage.setItem(this.STORAGE_USER_KEY, JSON.stringify(user));

        else
            window.localStorage.removeItem(this.STORAGE_USER_KEY);
    }

    static clearJWT() {
        window.sessionStorage.removeItem(this.STORAGE_TOKEN);
        window.localStorage.removeItem(this.STORAGE_TOKEN);
    }

    static clear() {
        window.sessionStorage.removeItem(this.STORAGE_USER_KEY);
        window.sessionStorage.removeItem(this.STORAGE_TOKEN);
        window.localStorage.removeItem(this.STORAGE_USER_KEY);
        window.localStorage.removeItem(this.STORAGE_TOKEN);
    }

}
